import { render, staticRenderFns } from "./SetupTukarPoin.vue?vue&type=template&id=4f303578"
import script from "./SetupTukarPoin.vue?vue&type=script&lang=js"
export * from "./SetupTukarPoin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports